export default __webpack_public_path__ + "static/media/Contacts.94278104.svg";